// Based on https://codepen.io/knoland/pen/XKxAJb

/**
 * Texture of water using 4 videos
 *
 */

var THREE = require('three');

import * as dat from 'dat.gui';
import { TweenMax, Power2 } from 'gsap';
import { visibleHeightAtZDepth, visibleWidthAtZDepth } from '../../../helpers/threejs-utils'
// import { preloadVideo } from '../../../helpers/video-utils';
import MyLoader from '../../../helpers/loader-utils';
import enableInlineVideo from 'iphone-inline-video';
import objectFitVideos from 'object-fit-videos';
import objectFitImages from 'object-fit-images';

var elDebugInfos = document.getElementById('debug-infos');

// const plugins = [ CSSPlugin ]

var Water = function () {

  var camera, scene;
  var water, flash;

  let videoWater; // = document.getElementById('video-water');
  const videoWater_step0 = document.getElementById('video-water_step0');
  const videoWater_step1 = document.getElementById('video-water_step1');
  const videoWater_step2 = document.getElementById('video-water_step2');
  const videoWater_step3 = document.getElementById('video-water_step3');
  const imageWater = document.getElementById('image-water');

  const imageSky = document.getElementById('image-sky');
  objectFitImages(imageSky);


  var WAVE_PERC_H = 0.5;
  var WAVE_PERC_H_MOBILE = 0.6;

  var oLoader = new MyLoader();

  var windowH, windowW;
  var waterH, waterW;

  var seaSpeed0 = 4.1;
  var seaSpeed1 = 20.1;
  var seaSpeed2 = 25.1;
  var seaSpeed3 = 30.1;

  var mousePcent = 0; // Between -1 and 1

  var timeUniform = {
    iGlobalTime: {
      type: 'f',
      value: 0.1
    },
    iResolution: {
      type: 'v2',
      value: new THREE.Vector2()
    },

    iWheelOrientation: {
      type: 'f',
      value: 0
    },
    iSpeed: {
      type: 'f',
      value: seaSpeed0
    },
    iSeaHeight: {
      type: 'f',
      value: 0.3
    },
    iSeaFreq: {
      type: 'f',
      value: 0.16
    },
    iSeaSpeed: {
      type: 'f',
      value: 1.0
    },
    iSeaChoppy: {
      type: 'f',
      value: 1.0
    }
  };

  // timeUniform.iResolution.value.x = window.innerWidth;
  // timeUniform.iResolution.value.y = document.documentElement.clientHeight; //window.innerHeight;

  var create = function (_scene, _camera, _renderer) {
    console.log('Water3 create()');

    // console.log(`🎥 BEFORE - DYNAMICALLY CHANGE VIDEO SOURCE`, videoWater_step0.src);

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
        // Use traditional 'for loops' for IE 11
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // console.log('}} A child node has been added or removed.');
            }
            else if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
                // console.log('🎥 OBSERVER : The ' + mutation.attributeName + ' attribute was modified.', mutation.target);
                // observer.disconnect();
                enableInlineVideo(mutation.target);
                objectFitVideos(mutation.target);
            }
        }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(videoWater_step0, config);
    observer.observe(videoWater_step1, config);
    observer.observe(videoWater_step2, config);
    observer.observe(videoWater_step3, config);

    // Later, you can stop observing
    // observer.disconnect();
    windowW = window.innerWidth
    let _s
    if (windowW < 961) {
      _s = videoWater_step0.dataset.videoMobile
      videoWater_step0.src = _s;
      _s = videoWater_step1.dataset.videoMobile
      videoWater_step1.src = _s;
      _s = videoWater_step2.dataset.videoMobile
      videoWater_step2.src = _s;
      _s = videoWater_step3.dataset.videoMobile
      videoWater_step3.src = _s;
      // var source = document.createElement('source');
      // source.type = 'video/mp4'
      // source.src = _s
      // videoWater_step0.append(source);
    } else if (windowW < 1025) {
      _s = videoWater_step0.dataset.videoTablet
      videoWater_step0.src = _s;
      _s = videoWater_step1.dataset.videoTablet
      videoWater_step1.src = _s;
      _s = videoWater_step2.dataset.videoTablet
      videoWater_step2.src = _s;
      _s = videoWater_step3.dataset.videoTablet
      videoWater_step3.src = _s;
      // var source = document.createElement('source');
      // source.type = 'video/mp4'
      // source.src = _s
      // videoWater_step0.append(source);
    } else {
      _s = videoWater_step0.dataset.video
      videoWater_step0.src = _s;
      _s = videoWater_step1.dataset.video
      videoWater_step1.src = _s;
      _s = videoWater_step2.dataset.video
      videoWater_step2.src = _s;
      _s = videoWater_step3.dataset.video
      videoWater_step3.src = _s;
    }
    // console.log(`🎥 AFTER - DYNAMICALLY CHANGE VIDEO SOURCE`, videoWater_step0.src);
    enableInlineVideo(videoWater_step0);
    enableInlineVideo(videoWater_step1);
    enableInlineVideo(videoWater_step2);
    enableInlineVideo(videoWater_step3);
    objectFitVideos(videoWater_step0);
    objectFitVideos(videoWater_step1);
    objectFitVideos(videoWater_step2);
    objectFitVideos(videoWater_step3);

    camera = _camera;
    scene = _scene;

    // var axis = new THREE.AxesHelper(100);
    // scene.add (axis);

    // Could preload all the vidéo using BLOB
    // https://dinbror.dk/blog/how-to-preload-entire-html5-video-before-play-solved/
    // videoWater = videoWater_step0
    // if (videoWater) {
    // oLoader.add('video-water-step0');
    // oLoader.add('video-water-step1');
    // oLoader.add('video-water-step2');
    // oLoader.add('video-water-step3');

      /* videoWater.addEventListener('progress', () => {
        var range = 0;
        var bf = videoWater.buffered;
        var time = videoWater.currentTime;

        try {
          while(!(bf.start(range) <= time && time <= bf.end(range))) {
              range += 1;
          }
        } catch(e) {
          console.log(`Error with buffer progress`, e);
        }
        var loadStartPercentage = bf.start(range) / videoWater.duration;
        var loadEndPercentage = bf.end(range) / videoWater.duration;
        var loadPercentage = loadEndPercentage - loadStartPercentage;
        console.log(`Video progress`, loadPercentage);
        if(loadPercentage > 0.9) oLoader.loaded('video-water-step0')
      }); */

    function onVideoError(e) {
      // console.error(`🎥 video step0 error`, e);
      elDebugInfos.innerHTML += `<br/>🎥 video step0 error`;
      // oLoader.loaded('video-water-step0')
      videoWater_step0.removeEventListener('error', onVideoError)
      videoWater_step0.removeEventListener('canplay', onVideoStep0Canplay)
    }

    function onVideoStep0Canplay() {
      // console.log(`🎥 video step0 canplay`);
      elDebugInfos.innerHTML += `<br/>🎥 video step0 canplay`;
      videoWater_step0.removeEventListener('error', onVideoError)
      videoWater_step0.removeEventListener('canplay', onVideoStep0Canplay)
      // oLoader.loaded('video-water-step0')
    }

    function onVideoStep1Canplay() {
      // console.log(`🎥 video step1 canplay`);
      elDebugInfos.innerHTML += `<br/>🎥 video step1 canplay`;
      videoWater_step1.removeEventListener('canplay', onVideoStep1Canplay)
      // videoWater_step1.pause()
      // TweenMax.to(videoWater_step1, 0.0, {autoApha: 0});

      videoWater_step1.style.display = 'none';
      // oLoader.loaded('video-water-step1')
    }

    function onVideoStep2Canplay() {
      // console.log(`🎥 video step2 canplay`);
      elDebugInfos.innerHTML += `<br/>🎥 video step2 canplay`;
      videoWater_step2.removeEventListener('canplay', onVideoStep2Canplay)
      // videoWater_step2.pause()
      // TweenMax.to(videoWater_step2, 0.0, {autoApha: 0});
      videoWater_step2.style.display = 'none';
      // oLoader.loaded('video-water-step2')

      // Load step3 video.
      // With ios 13.2 I can't delay video load and play, you need user interaction
      /* let _s
      if (windowW < 961) {
        _s = videoWater_step3.dataset.videoMobile
        videoWater_step3.src = _s;
      } else if (windowW < 1025) {
        _s = videoWater_step3.dataset.videoTablet
        videoWater_step3.src = _s;
      } else {
        _s = videoWater_step3.dataset.video
        videoWater_step3.src = _s;
      }
      enableInlineVideo(videoWater_step3);
      objectFitVideos(videoWater_step3);
      playVideo(videoWater_step3, true) // TODO: try to load it only when step2 canplay */
    }

    function onVideoStep3Canplay() {
      // console.log(`🎥 video step3 canplay`);
      elDebugInfos.innerHTML += `<br/>🎥 video step3 canplay`;
      videoWater_step3.removeEventListener('canplay', onVideoStep3Canplay)
      // videoWater_step3.pause()
      videoWater_step3.style.display = 'none';
      // oLoader.loaded('video-water-step3')
    }

    videoWater_step0.muted = videoWater_step1.muted = videoWater_step2.muted = videoWater_step3.muted = true
    videoWater_step0.addEventListener('error', onVideoError)
    videoWater_step0.addEventListener('canplay', onVideoStep0Canplay)
    videoWater_step1.addEventListener('canplay', onVideoStep1Canplay)
    videoWater_step2.addEventListener('canplay', onVideoStep2Canplay)
    videoWater_step3.addEventListener('canplay', onVideoStep3Canplay)
    playVideo(videoWater_step1, true)
    playVideo(videoWater_step2, true)
    playVideo(videoWater_step3, true)

    // preloadVideo(videoWater_step1, 'videos/water_step1.mp4', () => {oLoader.loaded('video-water-step1')});
    // preloadVideo(videoWater_step2, 'videos/water_step2.mp4', () => {oLoader.loaded('video-water-step2')});
    // preloadVideo(videoWater_step3, 'videos/water_step3.mp4', () => {oLoader.loaded('video-water-step3')});
    // }

    windowW = window.innerWidth;
    windowH = window.innerHeight;

    // WATER
    waterW = windowW;
    waterH = windowW > 600
      ? windowH * WAVE_PERC_H
      : windowH * WAVE_PERC_H_MOBILE;
    console.log(`water ${waterW} x ${waterH}`);

    // FLASH STEPS
    flash = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(
        visibleWidthAtZDepth( 1, camera),
        visibleHeightAtZDepth( 1, camera),
      ),
      new THREE.MeshBasicMaterial({
        transparent: true,
        opacity: 0,
        color: 0xc5e0f3
      })
    );
    flash.position.z = 1;
    scene.add(flash);

    resize();
    // initGUI();
  }

  var playVideo = function(elVideo, bPause) {
    if (!elVideo) {
      // Here we should play all the videos, because the user just clicked, hence ios autorize play

      // Video step1
      let playPromise1 = videoWater_step1.play()
      // console.log(`🎥 Launch all the video after click`);
      // console.log(`🎥 Play video`, videoWater_step1.src)
      elDebugInfos.innerHTML += `<br/>🎥 Play video : ${videoWater_step1.src}`;
      if (playPromise1 !== undefined) {
        playPromise1
          .then((_) => {
            // console.info(`🎥 Play started ${bPause ? 'pause video' : ''}`, videoWater_step1.src)
            elDebugInfos.innerHTML += `<br/>🎥 Play started : ${bPause ? 'pause video' : ''}`;
            if(bPause) videoWater_step1.pause()
            else videoWater_step1.currentTime = 0
          })
          .catch((error) => {
            // console.error(`🎥 Play error`, error)
            elDebugInfos.innerHTML += `<br/>🎥 <span style="color:#ff0000">Play error</span>`;
          })
      }

      // Video step2
      let playPromise2 = videoWater_step2.play()
      // console.log(`🎥 Launch all the video after click`);
      // console.log(`🎥 Play video`, videoWater_step2.src)
      elDebugInfos.innerHTML += `<br/>🎥 Play video : ${videoWater_step2.src}`;
      if (playPromise2 !== undefined) {
        playPromise2
          .then((_) => {
            // console.info(`🎥 Play started ${bPause ? 'pause video' : ''}`, videoWater_step2.src)
            elDebugInfos.innerHTML += `<br/>🎥 Play started : ${bPause ? 'pause video' : ''}`;
            if(bPause) videoWater_step2.pause()
            else videoWater_step2.currentTime = 0
          })
          .catch((error) => {
            // console.error(`🎥 Play error`, error)
            elDebugInfos.innerHTML += `<br/>🎥 <span style="color:#ff0000">Play error</span>`;
          })
      }

      // Video step3
      let playPromise3 = videoWater_step3.play()
      // console.log(`🎥 Launch all the video after click`);
      // console.log(`🎥 Play video`, videoWater_step3.src)
      elDebugInfos.innerHTML += `<br/>🎥 Play video : ${videoWater_step3.src}`;
      if (playPromise3 !== undefined) {
        playPromise3
          .then((_) => {
            // console.info(`🎥 Play started ${bPause ? 'pause video' : ''}`, videoWater_step3.src)
            elDebugInfos.innerHTML += `<br/>🎥 Play started : ${bPause ? 'pause video' : ''}`;
            if(bPause) videoWater_step3.pause()
            else videoWater_step3.currentTime = 0
          })
          .catch((error) => {
            // console.error(`🎥 Play error`, error)
            elDebugInfos.innerHTML += `<br/>🎥 <span style="color:#ff0000">Play error</span>`;
          })
      }
    }
    const _elVideo = elVideo ? elVideo : videoWater_step0
    if (_elVideo.paused) {
      const playPromise = _elVideo.play()
      // console.log(`🎥 Play video`, _elVideo.src)
      elDebugInfos.innerHTML += `<br/>🎥 Play video : ${_elVideo.src}`;
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            // console.info(`🎥 Play started ${bPause ? 'pause video' : ''}`, _elVideo.src)
            elDebugInfos.innerHTML += `<br/>🎥 Play started : ${bPause ? 'pause video' : ''}`;
            if(bPause) _elVideo.pause()
            else _elVideo.currentTime = 0
          })
          .catch((error) => {
            // console.error(`🎥 Play error`, error)
            elDebugInfos.innerHTML += `<br/>🎥 <span style="color:#ff0000">Play error</span>`;
          })
      }
    } else {
      _elVideo.currentTime = 0;
    }
  }

  var updateVideo = function(elVideo) {
    if (videoWater) {
      // console.log(`🎥 >>> updateVideo from ${videoWater.src} to ${elVideo.src}`);
      videoWater.style.zIndex = 0;
      videoWater.style.visibility = 'hidden';
      // TweenMax.to(videoWater, 1.0, {autoApha: 0});
      videoWater.pause();
      // console.log(`🎥 pause video`, videoWater.src);

      videoWater.src = '';
      videoWater.style.display = 'none';
    } else {
      // console.log(`🎥 >>> updateVideo to ${elVideo.src}`);
    }

    elVideo.style.zIndex = 1;
    elVideo.style.visibility = 'visible';
    elVideo.style.display = 'block';
    videoWater = elVideo;
    // console.log(`🎥 >>> new video playing is ${videoWater.src}`);
    elDebugInfos.innerHTML += `<br/>🎥 >>> new video playing is ${videoWater.src}`;
    playVideo(elVideo);
  }

  // Threejs Fit plane to screen :
  // https://gist.github.com/ayamflow/96a1f554c3f88eef2f9d0024fc42940f
  var resize = function () {
    windowW = window.innerWidth;
    windowH = document.documentElement.clientHeight; //window.innerHeight;
    // console.log(`WINDOW ::: ${windowH} vs ${document.documentElement.clientHeight}`);

    waterH = windowW > 600
      ? windowH * WAVE_PERC_H
      : windowH * WAVE_PERC_H_MOBILE;

    let dist = camera.position.z - 0; //water.position.z;
    camera.fov = 2 * Math.atan(waterH/ (2 * dist)) * (180 / Math.PI);
    camera.updateProjectionMatrix();

    // videoWater.style.height = `${ waterH }px`;
    videoWater_step0.style.height = `${ waterH }px`;
    videoWater_step1.style.height = `${ waterH }px`;
    videoWater_step2.style.height = `${ waterH }px`;
    videoWater_step3.style.height = `${ waterH }px`;
    imageWater.style.height = `${ waterH }px`;
    imageSky.style.height = `${ windowH - waterH }px`;

    flash.geometry.height = windowH;
  }

  var fillScreen = function () {
    const perspective = 800;
    const fov = 180 * (2 * Math.atan(innerHeight / 2 / perspective)) / Math.PI;
    // then align the Three.js perspective with the CSS3D perspective:
    camera = new THREE.PerspectiveCamera(fov, window.innerWidth / window.innerHeight, 1, 10000);
    camera.position.set(0, 0, perspective);
    document.body.style.perspective = `${perspective}px`;
  }

  var render = function () {
    // console.log(`Water - render()`, mousePcent);
    // timeUniform.iWheelOrientation.value += mousePcent * 0.1;
    // timeUniform.iGlobalTime.value += clock.getDelta();
    // oDisplacement.updateUniforms(mousePcent, clock.getElapsedTime());
  }

  function setWheelOrientation(pcent) {
    mousePcent = pcent;
  }

  var updateSpeed = function (type) {
    if (type == 'step0') {
      // timeUniform.iSpeed.value = seaSpeed0;
      // TweenMax.to(timeUniform.iSpeed, 0.1, {value:20});
      updateVideo(videoWater_step0);
    } else if (type == 'step1') {
      // timeUniform.iSpeed.value = seaSpeed1;
      // TweenMax.to(timeUniform.iSpeed, 0.1, {value:20});
      updateVideo(videoWater_step1);
      showFlashScreen();
    } else if (type == 'step2') {
      // timeUniform.iSpeed.value = seaSpeed2;
      // TweenMax.to(timeUniform.iSpeed, 0.1, {value:40});
      updateVideo(videoWater_step2);
      showFlashScreen();
    } else if (type == 'step3') {
      // timeUniform.iSpeed.value = seaSpeed3;
      // TweenMax.to(timeUniform.iSpeed, 0.1, {value:40});
      updateVideo(videoWater_step3);
      showFlashScreen();
    }
  }

  function showFlashScreen() {
    // flash.material.opacity = 1;
    TweenMax.to(flash.material, 0.1, {
      opacity: 0.8
    });
    TweenMax.to(flash.material, 1, {
      delay: 0.1,
      opacity: 0,
      ease: Power2.easeOut
    });
  }

  function initGUI() {
    // dat gui
    var gui = new dat.GUI();

    // var ambiantwheelDirectionGUI = wheelDirectionGUI.addFolder("ambiant");
    // ambiantwheelDirectionGUI.addColor(ambiantLightConfig, 'color').onChange(()=>{
    //     ambientLight.color = new THREE.Color( ambiantLightConfig.color );
    // });

    var wheelDirectionGUI = gui.addFolder("BOAT SPEED");
    wheelDirectionGUI.add(timeUniform.iSpeed, 'value', -2, 50).step(0.1);
    wheelDirectionGUI.open();

    var seaHeightGUI = gui.addFolder("SEA HEIGHT");
    seaHeightGUI.add(timeUniform.iSeaHeight, 'value', 0.1, 1).step(0.1);
    seaHeightGUI.open();

    var seaHeightGUI = gui.addFolder("SEA FREQ");
    seaHeightGUI.add(timeUniform.iSeaFreq, 'value', 0.01, 0.9).step(0.01);
    seaHeightGUI.open();

    var seaHeightGUI = gui.addFolder("SEA SPEED");
    seaHeightGUI.add(timeUniform.iSeaSpeed, 'value', 0.1, 2.0).step(0.1);
    seaHeightGUI.open();

    var seaHeightGUI = gui.addFolder("SEA CHOPPY");
    seaHeightGUI.add(timeUniform.iSeaChoppy, 'value', 0.1, 10.0).step(0.1);
    seaHeightGUI.open();
  }

  return {
    create,
    render,
    resize,
    playVideo,
    setWheelOrientation,
    updateSpeed
  };
}

export {
  Water as
  default
};
